<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    id="patrimoniesPrintTable"
    :initialFilters="filters"
  >

    

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="print">
        <!-- <BasePrint
          printableElementId="patrimoniesPrintTable"
          printButtonLabel="Imprimir"
          printTitle="Patrimônios"
          @start-printing="printing = loading = true"
          @stop-printing="printing = loading = false"
        /> -->

        <BasePrintPdf
          :pdfTitle="modelNamePlural"
          @pdf-open-action="(f) => loadPdf(f)"
          ref="nfePdfRef"
        />
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="8" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.patrimonyTotalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.patrimonyTotalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import BasePrint from "@shared_components/base_print.vue";
import BasePrintPdf from "@shared_components/base_print_pdf.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pdf: '',
      numPages: 1,
      pageLoading: false,
      totalItems: 0,
      patrimonyTotalPrice: null,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Cor", align: "left", sortable: true, value: "colorHexaCode" },
        { text: "Descrição", align: "left", sortable: true, value: "description" },
        { text: "Modelo", align: "left", sortable: true, value: "model" },
        { text: "Placa", align: "left", sortable: true, value: "plate" },
        { text: "UF", align: "left", sortable: false, value: "plateState.shortName" },
        { text: "Categoria", align: "left", sortable: true, value: "patrimonyCategory.name" },
        { text: "Marca", align: "left", sortable: true, value: "brand.name" },
        { text: "Valor do Bem", align: "left", sortable: true, value: "price" },
        { text: "Ativo", align: "left", sortable: true, value: "enabled" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'price', mask: 'currency' },
        { field: 'colorHexaCode', mask: 'color'},
        { field: "enabled", mask: "nice_boolean" },
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [{
        field: "enabled",
        fieldValues: [true],
        key: 0,
        operator: "in",
        type: "boolean"
      }], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Patrimônio"
    },
    modelNamePlural: {
      type: String,
      default: "Patrimônios"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BasePrint: BasePrint,
    BasePrintPdf: BasePrintPdf,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadPdf: function(f){
      // console.log('loadpdf');
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PATRIMONIES_PDF,
          variables: {
            input: { limit: 0, offset: 0, filters: this.filters }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.pdf = response.data.accountContext.patrimoniesIndexPdf.pdf;
          this.numPages = response.data.accountContext.patrimoniesIndexPdf.numPages;
          // console.log('num pages index', this.numPages);
          var obj = {pdf: this.pdf, numPages: this.numPages };
          // obj.numPages = this.numPages;
          // obj.pdf = this.pdf;
          // console.log('pdf', this.pdf);
          f(obj);
          
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
        
        // return {pdf: this.pdf, numPages: this.numPages};
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PATRIMONIES,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.patrimonies = response.data.accountContext.allPatrimonies;

          this.indexItems = response.data.accountContext.patrimoniesIndex.patrimonies; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.patrimoniesIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.patrimoniesIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.patrimoniesIndex.serverFields; // seta os campos que podem ser filtrados

          // this.pdf = response.data.accountContext.patrimoniesIndexPdf.pdf;
          // this.numPages = response.data.accountContext.patrimoniesIndexPdf.numPages;
          

          this.patrimonyTotalPrice = 0;
          for (var patrimony in this.indexItems) {
            this.patrimonyTotalPrice += this.indexItems[patrimony].price;
          }
          this.patrimonyTotalPrice = _.round(this.patrimonyTotalPrice, 2);
          // console.log("All Patrimonies", this.indexItems);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_PATRIMONIES = gql `
  query($input: IndexInputObject!) {
    accountContext {
      patrimoniesIndex(input: $input){
        count
        typeOperators
        serverFields      
        patrimonies {
          id
          code
          description
          enabled
          patrimonyCategory {
            name
          }
          model
          brand {
            name
          }
          price
          plate
          plateState {
            shortName
          }
          colorHexaCode
          canBeDeleted
          undeletabilityReasons
        }
      }      
    }
  }
`;

const LOAD_ALL_PATRIMONIES_PDF = gql `
  query($input: IndexInputObject!) {
    accountContext {     
      patrimoniesIndexPdf(input: $input)
    }
  }
`;

</script>

<style scoped></style>
